import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["goalType", "calorieFields", "weightFields"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const isWeight = this.goalTypeTarget.value === "weight"

    if (isWeight) {
      this.calorieFieldsTarget.classList.add("hidden")
      this.weightFieldsTarget.classList.remove("hidden")
    } else {
      this.calorieFieldsTarget.classList.remove("hidden")
      this.weightFieldsTarget.classList.add("hidden")
    }
  }
}
